"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneOffsetInMinutes = exports.clamp = exports.isOverlap = exports.getAfter = exports.getBefore = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
function getBefore(a, b) {
    return (0, date_fns_1.isBefore)(a, b) ? a : b;
}
exports.getBefore = getBefore;
function getAfter(a, b) {
    return (0, date_fns_1.isAfter)(a, b) ? a : b;
}
exports.getAfter = getAfter;
function isOverlap(a, b) {
    return !(a.end <= b.start || b.end <= a.start);
}
exports.isOverlap = isOverlap;
function clamp(date, minDate = null, maxDate = null) {
    if (minDate && (0, date_fns_1.isBefore)(date, minDate)) {
        return minDate;
    }
    if (maxDate && (0, date_fns_1.isAfter)(date, maxDate)) {
        return maxDate;
    }
    return date;
}
exports.clamp = clamp;
/**
 * 指定したタイムゾーンとUTCの時差を返す
 * @param tz タイムゾーン
 * @returns 時差の分
 */
function getTimezoneOffsetInMinutes(tz) {
    const offsetMillSec = (0, date_fns_tz_1.getTimezoneOffset)(tz);
    return offsetMillSec / (1000 * 60);
}
exports.getTimezoneOffsetInMinutes = getTimezoneOffsetInMinutes;
//# sourceMappingURL=dateUtil.js.map